import { digitChanger, monthChanger } from "helpers/helper";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function SingleTask({ item }) {
	const navigate = useNavigate();
	let content = item?.description
		? item?.description?.substring(0, 33) + "..."
		: "";
	const ekkLanguage = useSelector((state) => state.lan.lan);
	let checkStatus = (status) => {
		if (status === "Completed") {
			return (
				<div
					className='absolute top-0 bg-white py-1 px-3 border border-F27900'
					style={{ borderRadius: "10px 0 10px" }}>
					<p className='text-F27900'>{ekkLanguage.task.completed}</p>
				</div>
			);
		} else if (status === "Active") {
			return (
				<div
					className='absolute top-0 bg-white py-1 px-3 border border-success'
					style={{ borderRadius: "10px 0 10px" }}>
					<p className='text-success'>{ekkLanguage.task.onGoing}</p>
				</div>
			);
		} else if (status === "Cancelled") {
			return (
				<div
					className='absolute top-0 bg-white py-1 px-3 border border-primary'
					style={{ borderRadius: "10px 0 10px" }}>
					<p className='text-primary'>{ekkLanguage.task.cancelled}</p>
				</div>
			);
		} else {
			return "";
		}
	};

	return (
		<div
			onClick={() => navigate(`/task-details-public/${item?.id}`)}
			className='bg-white overflow-hidden rounded-xl cursor-pointer relative transform transition-all duration-300 hover:scale-105 hover:shadow-2xl group'
			style={{ boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)" }}>
			{checkStatus(item?.status)}

			{item?.images?.length ? (
				<div className='h-[250px] overflow-hidden relative'>
					<img
						src={item?.images[0]}
						alt='blogImage'
						className='object-cover w-full h-full transform transition-transform duration-300 group-hover:scale-110'
					/>
					<div className='absolute inset-0 bg-gradient-to-t from-black/30 to-transparent'></div>
				</div>
			) : (
				<div className='h-[250px] overflow-hidden flex bg-gradient-to-br from-orange-50 to-orange-100'>
					<img
						src='/assets/images/logo_icon.png'
						alt='blogImage'
						className='m-auto w-[200px] object-cover opacity-80'
					/>
				</div>
			)}

			<div className='pt-5 px-6 pb-5'>
				<h5 className='text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 pb-3 h-[45px] md:h-[76px] line-clamp-2 group-hover:text-orange-600 transition-colors'>
					{item.title?.length > 30
						? item.title?.substring(0, 35) + "..."
						: item?.title}
				</h5>

				<div className='flex justify-between py-4 border-t border-b border-gray-100'>
					<div className='space-y-2'>
						<div className='flex items-center gap-1'>
							<svg className='w-4 h-4 text-orange-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
								<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' />
							</svg>
							<h6 className='font-semibold text-gray-600 text-xs'>
								{ekkLanguage.task.taskStart}:
							</h6>
							<span className='text-gray-800 font-semibold text-xs'>
								{digitChanger(
									monthChanger(
										moment(item?.start_date).format("DD MMM, YY")
									)
								)}
							</span>
						</div>
						<div className='flex items-center gap-1'>
							<svg className='w-4 h-4 text-orange-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
								<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' />
							</svg>
							<h6 className='font-semibold text-gray-600 text-xs'>
								{ekkLanguage.task.taskEnd}:
							</h6>
							<span className='text-gray-800 font-semibold text-xs'>
								{digitChanger(
									monthChanger(
										moment(item?.end_date).format("DD MMM, YY")
									)
								)}
							</span>
						</div>
					</div>
					<div className='space-y-2'>
						<div className='flex items-center gap-1'>
							<svg className='w-4 h-4 text-blue-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
								<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' />
							</svg>
							<h6 className='font-semibold text-gray-600 text-xs'>
								{ekkLanguage.task.position}:
							</h6>
							<span className='text-gray-800 font-semibold text-xs'>
								{digitChanger(item?.required_volunteer)}
							</span>
						</div>
						<div className='flex items-center gap-1'>
							<svg className='w-4 h-4 text-blue-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
								<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' />
							</svg>
							<h6 className='font-semibold text-gray-600 text-xs'>
								{ekkLanguage.task.jointed}:
							</h6>
							<span className='text-gray-800 font-semibold text-xs'>
								{digitChanger(item?.enrolled_volunteer)}
							</span>
						</div>
					</div>
				</div>

				<div className='mt-4'>
					<p className='text-sm text-gray-600 leading-relaxed mb-3'>
						{content}
					</p>
					<div className='flex items-center text-orange-600 font-semibold text-sm group-hover:text-orange-700 transition-colors'>
						<span>{ekkLanguage.task.readMore}</span>
						<svg className='w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
							<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
}
